import React from 'react'
import { css, useTheme } from '@emotion/react'
import { Divider, Typography, Link } from '../base-ui'
import Image from '../base-ui/Image'
import AddressIcon from './AddressIcon'
import {
    AiOutlinePushpin,
    AiOutlineMobile,
    AiOutlineMail,
} from 'react-icons/ai'
import { useTranslation } from 'next-i18next'
import config from '../../../config.json'
import Script from 'next/script'

function FooterAbout({
    src,
    touchInfo,
    social,
    lineClamp = 6,
    more = true,
    latest = true,
    cutsomContent,
    style,
}) {
    const theme = useTheme()
    const { t } = useTranslation(['common'])
    const enhancedStyle = css`
        display: flex;
        flex-direction: column;
        padding: 3rem;
        height: 100%;
        .site-logo {
            margin-bottom: 1rem;
        }
        ${style}
    `
    return (
        <div css={enhancedStyle}>
            {src && (
                <div className="site-logo">
                    <Image
                        noStyle
                        src={src}
                        width={
                            config.theme?.components?.logoFooter
                                ?.width ?? 250
                        }
                        height={
                            config.theme?.components?.logoFooter
                                ?.height ?? 80
                        }
                        objectFit="contain"
                        alt="site logo"
                    />
                </div>
            )}
            {cutsomContent}
            {'-------------------------'}
            <Typography
                type="p"
                color={theme?.colors?.websiteFooter?.color}
                lineClamp={lineClamp}
            >
                <span dangerouslySetInnerHTML={{ __html: config.texts?.footer_about }} />
            </Typography>
            {latest && (
                <Link href="/latest">
                    {t('آخرین اخبار', {
                        ns: 'news',
                    })}
                </Link>
            )}
            {more && (
                <Link href="/about" style={{ textTransform: 'capitalize' }}>
                    {t('درباره ما', {
                        ns: 'common',
                    })}
                </Link>
            )}
            {config?.integrations?.namad?.code && <>
                <div id={`div_eRasanehTrustseal_${config.integrations.namad.code}`}></div>
                <Script id="namad_src" src="https://trustseal.e-rasaneh.ir/trustseal.js" />
                <Script id="namad_init" dangerouslySetInnerHTML={{
                    __html: `window.addEventListener('load', function() {
  eRasaneh_Trustseal(${config.integrations.namad.code}, false);
})`}} />
            </>}
            <Divider width="100%" />
            {touchInfo && (
                <>
                    <AddressIcon
                        icon={<AiOutlinePushpin />}
                        content={touchInfo?.address}
                    />
                    <AddressIcon
                        icon={<AiOutlineMobile />}
                        content={touchInfo?.tel}
                    />
                    <AddressIcon
                        icon={<AiOutlineMail />}
                        content={touchInfo?.mail}
                    />
                </>
            )}
            {social}
        </div>
    )
}

export default FooterAbout
